export class Action {
    ID: number;
    FullName: string;
}

export default Action;